import type { ReactNode } from "react";
import { ShortcutKbd } from "@/core/components/ui/kbd";
import { Stack } from "@/core/components/ui/stack";
import type { ShortcutKey } from "@/core/utils/desktop-platform";

export const TooltipShortcut = ({
  keys,
  children,
}: {
  keys: readonly ShortcutKey[];
  children: ReactNode;
}) => (
  <Stack direction="row" gap="sm" align="center">
    {children}
    <ShortcutKbd keys={keys} />
  </Stack>
);
